import {
  TriplePServiceDatasource,
  TriplePServiceDatasourceConfig,
} from "./TriplePService/TriplePServiceDatasource";
import {
  Auth0Datasource,
  Auth0DatasourceConfig,
} from "./Auth0/Auth0Datasource";
import { StaxDatasource, StaxDatasourceConfig } from "./Stax/StaxDatasource";

export * from "./TriplePService/TriplePInterface";
export * from "./Auth0/Auth0DatasourceInterface";
export * from "./Stax/StaxInterface";

const triplePSDatasourceConfig: TriplePServiceDatasourceConfig = {
  baseURL: process.env.REACT_APP_TRIPLEP_API_URL ?? "",
};
export const triplePSDatasource = new TriplePServiceDatasource(
  triplePSDatasourceConfig
);

const auth0DatasourceConfig: Auth0DatasourceConfig = {
  baseURL: process.env.REACT_APP_AUTH0_URL ?? "",
};
export const auth0Datasource = new Auth0Datasource(auth0DatasourceConfig);

const staxDatasourceConfig: StaxDatasourceConfig = {
  baseURL: process.env.REACT_APP_STAX_API_URL || "",
  apiKey: process.env.REACT_APP_STAX_API_KEY || "",
};
export const staxDatasource = new StaxDatasource(staxDatasourceConfig);
